import { Checkbox, TableCell, TableRow } from "@mui/material";
import { memo, useState } from "react";
import { TableBackOfficeEndData } from "../../general/TableFunctions";
import { TableBackOfficeSensitiveBD } from "./TableSensitiveBD";
import { TableBackOfficeSensitiveTenant } from "./TableSensitiveTenant";
import { AppDispatch, RootState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { useGetCompaniesFilteredQuery } from "../../../store/api/backoffice/backofficeApi";
import { changeSelectedCompanies } from "../../../store/slices/backoffice/backofficeSelectedCompaniesSlice";
import { Link } from "react-router-dom";

interface TableBackOfficeRowProps {
  index: number;
  item: any;
  isSelected: boolean;
  onSelect: () => void;
}

export const TableBackOfficeRow = memo(function TableData({ index, item, isSelected, onSelect }: TableBackOfficeRowProps) {
    const dispatch = useDispatch<AppDispatch>()
    const backofficeCompanies = useSelector((state: RootState) => state.backofficeCompanies)
    const backofficeSelectedCompanies = useSelector((state: RootState) => state.backofficeSelectedCompanies)
    const { data: backofficeCompaniesRawData } = useGetCompaniesFilteredQuery(backofficeCompanies.filters)
    let [show, setShow] = useState(false)

    const handleNewTimeSheet = (item: any) => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
   
    const handleCheckClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onSelect();
        
        const companyId = item.companyDatabaseId;
        const currentSelectedIds = [...backofficeSelectedCompanies.companiesIds];
        
        if (isSelected) {
            // Remove o ID da lista de selecionados
            const updatedIds = currentSelectedIds.filter(id => id !== companyId);
            dispatch(changeSelectedCompanies({ companiesIds: updatedIds }));
        } else {
            // Adiciona o ID à lista de selecionados
            const updatedIds = [...currentSelectedIds, companyId];
            dispatch(changeSelectedCompanies({ companiesIds: updatedIds }));
        }
    }
      
    return (
        <TableRow
        key={index} 
        id="tableRow" 
        hover={true} 
        selected={isSelected} 
        onClick={() => handleNewTimeSheet(item)}
        sx={{ cursor: 'pointer', backgroundColor: "none" }}>
        <TableCell component="th" scope="row">
          <Checkbox 
            checked={isSelected} 
            onClick={handleCheckClick}
          />
        </TableCell>
        <TableCell>
          {item.companyName}
        </TableCell>
        <TableCell>
          {item.companyDatabaseId}
        </TableCell>
        {/* <TableCell>
            <TableBackOfficeSensitiveTenant isShown={show} tenant={item.tenants} />
        </TableCell>
        <TableCell>
            <TableBackOfficeSensitiveBD connection={item.databaseName} connectionUp={item.isActive} isShown={show} />
        </TableCell>
        <TableCell>
            <TableBackOfficeSensitiveBD connection={item.databaseName} connectionUp={item.isActive} isShown={show} />
        </TableCell> */}
        <TableCell>
          {item.driversCount}
        </TableCell>
        <TableCell>
          <Link to={`/companies/${item.companyDatabaseId}`} state={item}>
            <TableBackOfficeEndData />
          </Link>
        </TableCell>
      </TableRow>
    )
});